export const validateInput = (value: string, regex: RegExp) => {
    if (value !== '') {
        return regex.test(value);
    }
    return true;
};
